import { ROUTES } from './routeRegistry';

/**
 * Converts a route template from {@link ROUTES} (with `:param` segments) to a full-path regex.
 * Supports optional dynamic segments written as `/segment/:param?` in the template string.
 */
export function routeTemplateToRegex(template: string): RegExp {
  let t = template;
  t = t.replaceAll(/\/:[^/]+\?/g, '(?:/[^/]+)?');
  const segments = t.split('/').filter((s) => s.length > 0);
  const parts: string[] = ['^'];
  for (const seg of segments) {
    if (seg.startsWith(':')) {
      parts.push('/[^/]+');
    } else {
      parts.push(`/${escapeRegexSegment(seg)}`);
    }
  }
  parts.push('$');
  return new RegExp(parts.join(''));
}

function escapeRegexSegment(s: string): string {
  return s.replaceAll(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const registryTemplates = Object.values(ROUTES) as string[];

/** Literal paths from the route registry (no dynamic segments). */
export function getRouteRegistryLiterals(): ReadonlySet<string> {
  return new Set(registryTemplates.filter((t) => !t.includes(':')));
}

/**
 * Returns true if `pathname` (no query/hash) exactly matches a registry literal
 * or fully matches a parametrized registry template.
 */
export function pathMatchesRouteRegistry(pathname: string): boolean {
  const clean = pathname.split('?')[0]?.split('#')[0] ?? pathname;
  for (const template of registryTemplates) {
    if (!template.includes(':')) {
      if (clean === template) return true;
      continue;
    }
    if (routeTemplateToRegex(template).test(clean)) return true;
  }
  return false;
}
